import { fmtMoney } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, Loader2, Sparkle, Wand2 } from "lucide-react";

export const SceneComposer = ({
  presets, selectedPreset, setSelectedPreset, customPrompt, setCustomPrompt,
  selectedGarment, generating, sessionClosed, fee, onGenerate,
}) => (
  <Card className="rounded-2xl">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-base"><Sparkle className="h-4 w-4" /> Scene & generation</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">Preset backgrounds</Label>
        <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-4">
          {presets.map((p) => (
            <button key={p.key} type="button" data-testid={`studio-preset-${p.key}`}
              onClick={() => setSelectedPreset(selectedPreset === p.key ? null : p.key)}
              className={`rounded-xl border p-2.5 text-left text-xs transition-[border-color,background-color] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
                selectedPreset === p.key
                  ? "border-[hsl(174,38%,34%)] bg-[hsl(174,38%,95%)] font-semibold"
                  : "bg-card hover:bg-muted"
              }`}>
              {p.label}
              {selectedPreset === p.key && <Check className="ml-1 inline h-3 w-3 text-[hsl(174,38%,34%)]" />}
            </button>
          ))}
        </div>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">Custom scene prompt (optional)</Label>
        <Textarea data-testid="studio-prompt-input" rows={2} maxLength={600}
          placeholder='e.g. "Studio lighting, minimalist cafe background, warm summer afternoon"'
          value={customPrompt} onChange={(e) => setCustomPrompt(e.target.value)}
          className="mt-2 rounded-xl bg-card text-sm" />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 border-t pt-4">
        <p className="text-[11px] text-muted-foreground">
          {selectedGarment ? <>Garment: <span className="font-semibold text-foreground">{selectedGarment.name}</span></> : "Select a garment on the left"}
          {" · "}AI keeps its texture & branding intact while draping it on the twin.
        </p>
        <Button data-testid="studio-generate-button" disabled={generating || sessionClosed} onClick={onGenerate} className="rounded-xl">
          {generating ? (
            <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Generating… (20–90s)</>
          ) : (
            <><Wand2 className="mr-2 h-4 w-4" /> Generate image · {fmtMoney(fee)}</>
          )}
        </Button>
      </div>
    </CardContent>
  </Card>
);
